// extracted by mini-css-extract-plugin
export var root = "_143ad16e139570d34dcd763864830382-css";
export var root_align_center = "_62f04ad7919801049c36d8120dff6c2f-css";
export var root_align_right = "_390cc0a90505cc956eb5b5fd5bab2d38-css";
export var root_valign_center = "_2503e3befc655601400bfcc6c067daba-css";
export var root_noWrap = "_413f2de1a3cc3b8eb6afb78d74bbe94d-css";
export var item = "f6a2446656d4325b818bc75cef7d099f-css";